import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Calendar } from "lucide-react";

export default function Connect() {
  const cards = [
    {
      id: 1,
      title: "WBC Open Championship 2026",
      image: "url('https://minf-minf.s3.ap-south-1.amazonaws.com/814f97f5-951e-4178-aefb-69bea61ad93e.jpg')",
      category: "Sports",
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Provident quisquam recusandae distinctio eum nesciunt.",
      date: "March 15, 2024"
    },
    {
      id: 2,
      title: "Tech Revolution",
      image: "url('https://minf-minf.s3.ap-south-1.amazonaws.com/814f97f5-951e-4178-aefb-69bea61ad93e.jpg')",
      category: "Technology",
      description: "Exploring the latest technological advancements that are shaping our future.",
      date: "March 14, 2024"
    },
    {
      id: 3,
      title: "Art & Culture",
      image: "url('https://minf-minf.s3.ap-south-1.amazonaws.com/814f97f5-951e-4178-aefb-69bea61ad93e.jpg')",
      category: "Arts",
      description: "A deep dive into contemporary art movements and cultural expressions.",
      date: "March 13, 2024"
    },
    {
      id: 4,
      title: "Health & Wellness",
      image: "url('https://minf-minf.s3.ap-south-1.amazonaws.com/814f97f5-951e-4178-aefb-69bea61ad93e.jpg')",
      category: "Health",
      description: "Discover the latest trends in health and wellness practices.",
      date: "March 12, 2024"
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { 
        duration: 0.4,
        ease: [0.16, 1, 0.3, 1],
        staggerChildren: 0.1
      }
    }
  };

  return (
    <section className="bg-transparent mb-12 mt-24">
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 container mx-auto px-4"
        variants={cardVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {cards.map((card) => (
          <motion.div
            key={card.id}
            className="w-full bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
            variants={cardVariants}
          >
            <div
              className="h-[220px] w-full relative group"
              style={{ backgroundImage: card.image, backgroundSize: 'cover', backgroundPosition: 'center' }}
            />
            <div className="px-5 py-3 space-y-2">
              <motion.p
                className="text-lg font-semibold text-gray-800 hover:text-gray-600 transition-colors duration-300"
                whileHover={{ scale: 1.02 }}
              >
                {card.title}
              </motion.p>
              <div className="h-[1px] w-full bg-gray-100"/>
              <p className="text-sm text-gray-600 line-clamp-2">
                {card.description}
              </p>
              <div className="flex items-center justify-between text-[10px] pt-2 text-gray-500">
                <div className="flex items-center gap-1">
                  <Calendar className="w-3 h-3" />
                  <span>{card.date}</span>
                </div>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="flex items-center gap-2 px-2 py-1 rounded-full text-[10px] hover:bg-gray-50 transition-colors duration-300"
                >
                  Read more
                  <ArrowRight className="w-3 h-3" />
                </motion.button>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
